import { FC, ForwardedRef } from 'react';
import { IS_PRERENDER } from '@namespace/helpers';

import styles from './index.module.css';

interface IframeProps {
  src?: string;
  className?: string | object;
  title?: string;
  content?: string | null;
  frameRef?: ForwardedRef<HTMLIFrameElement>;
  [key: string]: unknown;
}

export const Iframe: FC<IframeProps> = ({
  src,
  className = '',
  title = '',
  content = null,
  frameRef,
  ...rest
}) => {
  if (IS_PRERENDER) {
    return null;
  }

  return (
    <iframe
      src={src}
      className={`${styles.iframe} ${className}`}
      title={title}
      srcDoc={content ?? undefined}
      {...rest}
      ref={frameRef}
    />
  );
};
